/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable react/react-in-jsx-scope */
import { createContext, useContext, useState } from 'react';
import axios from 'axios';

export const CommonContext = createContext();


const CommonContextProvider = (props) => {

    const [organisationList, SetOrganisationList] = useState();
    const [patientDeatils, setPatientDeatils] = useState();
    const [familyDetails, setFamilyDetails] = useState();
    const [countryList, setCountryList] = useState();
    const [orgFees, setOrgFees] = useState();
    const [orgDoctors, setOrgDoctors] = useState();
    const [countries, setCountries] = useState();
    const [states, setStates] = useState();
    const [districts, setDistricts] = useState();
    const [localbodytype, setLocalbodytype] = useState();
    const [localbodys, setLocalbodys] = useState();


	
    const organisationGet = (orgtypesId) =>{

        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/organisations?orgtypesId=${orgtypesId}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    SetOrganisationList(response.data.data);
                }
            })
            .catch((error) => {
                console.log(error);
                // setDropOpen(false);
                // setOpen(true);
                // setErrorMessasge(error.response.data.message);
            });

    };

    const profileGet = () =>{

        const accessToken = sessionStorage.getItem('jwt');

        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/patientdetails?accessToken=${accessToken}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setPatientDeatils(response.data.data);
                }
            })
            .catch((error) => {
                console.log(error);
                // setDropOpen(false);
                // setOpen(true);
                // setErrorMessasge(error.response.data.message);
            });

    };

    const familyGet = () =>{

        const patientId = localStorage.getItem('FAMILY_PATIENT_ID');
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/familydetails?parentId=${patientId}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setFamilyDetails(response.data.data);
                }
            })
            .catch((error) => {
                console.log(error);
                // setDropOpen(false);
                // setOpen(true);
                // setErrorMessasge(error.response.data.message);
            });

    };

    const getCountry = () => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/countries`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setCountryList(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getOrgFees = (doctorsId, feeId) => {
        let params = '';
        if(feeId) {
            params += `&feeTypeId=${feeId}`;
        }
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/orgfees?doctorsId=${doctorsId}${params}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setOrgFees(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getOrgDoctors = (doctorsId) => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/orgdoctors?doctorsId=${doctorsId}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setOrgDoctors(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getCountries = () => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/countries`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setCountries(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getState = (country) => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/states?country=${country}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setStates(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getDistricts = () => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/districts`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setDistricts(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getLocalbodytype = () => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/localbodytype`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setLocalbodytype(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const getLocalbodys = (districtId,localbodyTypeId) => {
        let config = {
            method: 'get', 
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_BASE_URL}/localbodys?districtId=${districtId}&localbodyTypeId=${localbodyTypeId}`,
            headers: {
                'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
                'Content-Type': 'application/json',
                Authorization: sessionStorage.jwt,
                'x-api-version': process.env.REACT_APP_X_API_VERSION,
            },
            data: { 
  
            }
        };
  
        axios
            .request(config)
            .then((response) => {
                if (response.status === 200) {
                    setLocalbodys(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    return (
        <CommonContext.Provider value={{ organisationGet, organisationList, profileGet, patientDeatils , familyGet, familyDetails, getCountry, countryList, getOrgFees, orgFees, getOrgDoctors, orgDoctors,
            getCountries, countries, getState, states, getDistricts, districts, getLocalbodytype, localbodytype, getLocalbodys, localbodys
        }}>{props.children}</CommonContext.Provider>
    );
};

export const useAuth = () => useContext(CommonContext);

export default CommonContextProvider;